import {COLORS} from '../utils/style-variables';

import {TEXT} from './typography-style';

export const desktopSelectorStyles = {
  control: () => ({
    borderRadius: 2,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: COLORS.lightGrey60Color
  }),
  menu: () => ({}),
  valueContainer: () => ({
    padding: '7px 7px 7px 5px',
    '-webkit-overflow-scrolling': 'touch',
    position: 'relative',
    overflow: 'hidden',
    boxSizing: 'border-box'
  }),
  groupHeading: () => ({
    backgroundColor: 'transparent',
    color: COLORS.greyColor,
    display: 'block',
    padding: '10px 8px',
    width: '100%',
    userSelect: 'none',
    ...TEXT.defaultSize,
    '-webkit-tap-highlight-color': 'rgba(0,0,0,0)'
  }),
  group: () => ({}),
  option: () => ({
    backgroundColor: 'transparent',
    color: COLORS.blackColor,
    cursor: 'pointer',
    display: 'block',
    width: '100%',
    height: 40,
    userSelect: 'none',
    '-webkit-tap-highlight-color': 'transparent',
    boxSizing: 'border-box',
    padding: '10px 8px',
    ...TEXT.defaultSize,
    '&:hover': {
      backgroundColor: 'rgb(222, 235, 255)'
    }
  })
};
export const mobileSelectorStyles = {
  control: () => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    marginRight: 16,
    padding: '3px 0',
    borderRadius: 2,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: COLORS.lightGrey60Color
  }),
  menuList: () => ({
    maxHeight: 'calc(100vh - 120px)',
    overflowY: 'auto',
    padding: '4px 16px',
    position: 'relative',
    '-webkit-overflow-scrolling': 'touch'
  }),
  option: () => ({
    backgroundColor: 'transparent',
    color: 'inherit',
    display: 'block',
    padding: '18px 0',
    width: '100%',
    userSelect: 'none',
    borderWidth: 1,
    borderBottomStyle: 'solid',
    borderColor: COLORS.lightGrey30Color,
    '-webkit-tap-highlight-color': 'rgba(0,0,0,0)',
    ...TEXT.defaultSize
  }),
  groupHeading: () => ({
    backgroundColor: 'transparent',
    color: COLORS.greyColor,
    display: 'block',
    fontWeight: 'bold',
    padding: '18px 0',
    width: '100%',
    userSelect: 'none',
    borderWidth: 1,
    borderBottomStyle: 'solid',
    borderColor: COLORS.lightGrey30Color,
    '-webkit-tap-highlight-color': 'rgba(0,0,0,0)',
    ...TEXT.defaultSize
  }),
  group: () => ({}),
  menu: () => ({})
};
